module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/routes/event/event-events/event-events.component.scss
// module id = ./src/app/routes/event/event-events/event-events.component.scss
// module chunks = 9